<template>
  <v-row justify="center">
    <v-dialog :value="dialog" max-width="1000" persistent @input="closeModal">
      <v-card class="card">
        <v-card-title class="headline accent--text pb-4">
          {{ isEdit ? 'Редактировать' : 'Добавить' }}
        </v-card-title>
        <v-card-text outlined tile class="border-top py-0">
          <v-container class="px-0">
            <v-row>
              <h3 class="mb-2 ml-4 mt-6">Выберите заявление</h3>

              <v-col cols="12" class="py-0">
                <v-card class="card" :elevation="1">
                  <v-card-title>
                    <v-text-field
                      v-model="applicationSearch"
                      append-icon="mdi-magnify"
                      label="Поиск"
                      clearable dense outlined rounded hide-details
                    />
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      class="table elevation-0"
                      :headers="tableHeaders"
                      :loading="applicationLoading"
                      :items="applicationItems.list"
                      :search="applicationSearch"
                      :items-per-page="-1"
                      :height="250"
                      dense hide-default-footer fixed-header
                      no-results-text="Нет подходящих заявлений"
                    >
                      <template #item="{ item, index }">
                        <tr @click="selectApplication(item)" class="cursor-pointer" :class="{ selectedRow: protocolLine.application.id === item.id }" :key="index">
                          <td class="text-start" v-for="header in tableHeaders">{{ item[header.value] }}</td>
                        </tr>
                      </template>

                      <template slot="no-data">
                        <div>Нет заявлений</div>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" class="pb-0 mt-6 pt-0">
                <v-autocomplete
                  label="Решение" placeholder="Выберите из списка"
                  v-model="protocolLine.decision"
                  :items="decisions" item-text="name"
                  outlined rounded dense return-object
                  @input="$v.protocolLine.decision.$touch()"
                  @blur="$v.protocolLine.decision.$touch()"
                  :error-messages="errorMessages.decision"
                />
              </v-col>

<!--              <v-col cols="12" class="py-0">-->
<!--                <v-autocomplete-->
<!--                  label="Заявление" placeholder="Поиск по ФИО от 3 букв"-->
<!--                  v-model="protocolLine.application"-->
<!--                  :items="applicationItems" item-value="id" item-text="fullName"-->
<!--                  :search="applicationSearch"-->
<!--                  :loading="applicationLoading"-->
<!--                  :error-messages="errorMessages.application"-->
<!--                  outlined rounded dense return-object hide-no-data-->
<!--                  @input="$v.protocolLine.application.$touch()"-->
<!--                  @blur="$v.protocolLine.application.$touch()"-->
<!--                  @update:search-input="getApplicationItems"-->
<!--                >-->
<!--                  <template #prepend-item>-->
<!--                    <div class="ml-4 mb-2">ФИО / Статус / Дата заявления</div>-->
<!--                    <v-divider></v-divider>-->
<!--                  </template>-->

<!--                  <template v-slot:item="data">-->
<!--                    {{ data.item.fullName }} / {{ data.item?.applicationStatus?.name }} / {{ data.item.sendDateTime }}-->
<!--                  </template>-->
<!--                </v-autocomplete>-->
<!--              </v-col>-->
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="px-6">
          <v-spacer></v-spacer>
          <v-btn text color="lightGrey" @click="closeModal"> {{ isShowMode ? 'Закрыть' : 'Отмена' }} </v-btn>
          <v-btn
            v-if="!isShowMode"
            :loading="saveBtnLoading"
            :disabled="$v.$invalid || isShowMode"
            color="success"
            text
            @click="saveProtocolLine"
          >
            {{ isEdit ? 'Сохранить' : 'Создать' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {
  required,
  maxLength
} from 'vuelidate/lib/validators'
import {
  ApplicationDtoList,
  ProtocolLine
} from '@/models'
import {
  requiredObjectId,
  setValidateMessages } from '@/scripts/validation'
import {
  decisionApi,
  applicationApi,
} from '@/api'
import _, {cloneDeep} from "lodash";
import PageTable from '@/components/ui/Table'

export default {
  components: {
    PageTable
  },

  props: {
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    dialog: Boolean,
    selectedItem: Object
  },

  async created() {
    await this.loadCatalogs()
    await this.getApplications()
  },

  data: () => ({
    protocolLine: new ProtocolLine(),

    applicationSearch: '',
    applicationItems: new ApplicationDtoList(),
    tableHeaders: [
      { text: 'Номер', value: 'id', sortable: false, align: 'start' },
      { text: 'ФИО', value: 'fullName', sortable: false, align: 'start' },
      { text: 'Статус', value: 'applicationStatusText', sortable: false, align: 'start' },
      { text: 'Тип заявления', value: 'applicationTypeText', sortable: false, align: 'start' },
      { text: 'Специальность', value: 'specialityToText', sortable: false, align: 'start' },
      { text: 'Курс', value: 'courseNumberToText', sortable: false, align: 'start' },
      { text: 'Тип обучения', value: 'paidFormToText', sortable: false, align: 'start' },
      { text: 'Дата отправки', value: 'sendDateTimeText', sortable: false, align: 'start' },
    ],

    applicationLoading: false,

    decisions: []
  }),

  validations() {
    return {
      protocolLine: {
        application: { requiredObjectId: requiredObjectId },
        decision: { required }
      }
    }
  },

  computed: {
    isEdit() {
      return this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.protocolLine.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.protocolLine[key])
      })

      return allErrors
    }
  },

  methods: {
    async getApplications() {
      this.applicationLoading = true
      try {
        const data = await applicationApi.findNotNullTestScore({})
        this.applicationItems = new ApplicationDtoList(data)
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.applicationLoading = false
      }
    },

    async loadCatalogs() {
      const [decisions] = await Promise.all([decisionApi.getCatalog()])

      this.decisions = decisions
    },

    saveProtocolLine() {
      this.$emit('saveProtocolLine', this.protocolLine.getForShortAPI())
    },

    // getApplicationItems: _.debounce(async function(value) {
    //   try {
    //     if (value?.length >= 3 && !this.applicationItems.find(item => item.name === value)) {
    //       this.applicationLoading = true
    //       this.applicationItems = await applicationApi.findNotNullTestScore({})
    //     }
    //   } catch (e) {
    //     this.showErrorMessage(e)
    //   } finally {
    //     this.applicationLoading = false
    //   }
    // }, 500),

    selectApplication(item) {
      this.protocolLine.application = cloneDeep(item)
    },

    resetModal() {
      this.$v.$reset()
      this.protocolLine = new ProtocolLine()
    },

    closeModal() {
      this.protocolLine = new ProtocolLine()
      this.$emit('closeModal')
    }
  },

  watch: {
    selectedItem(val) {
      this.protocolLine = val ? ProtocolLine.buildFromAPI(val) : new ProtocolLine()
    },

    dialog(val) {
      !val && this.resetModal()
    }
  }
}
</script>

<style scoped>
.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.card >>> .v-label.theme--light {
  font-size: 14px;
  color: rgba(55, 71, 79, .8) !important;
}

.card >>> .v-label.v-label--active.theme--light {
  font-size: 16px;
}

.card >>> .v-label.v-label--active.primary--text.theme--light {
  color: #2196f3 !important
}

.table >>> tbody tr.selectedRow {
  background-color: #E8E8E8 !important;
}

.table >>> tbody tr.selectedRow:hover {
  background-color: #E8E8E8 !important;
}

.cursor-pointer{
  cursor: pointer;
}

.card {
  border-radius: 20px !important;
}
</style>